import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import AuthServices from "../services/AuthServices";
import AccessDenied from "../pages/general/AccessDenied";

/**
 * React-Router guard:
 * - Requires login (token cookie)
 * - If `requiredRoles` is provided, only allows matching `user.roleid`.
 */
const RequireRole = ({ requiredRoles, children }) => {
  const navigate = useNavigate();

  const isAuthed = AuthServices.isAuthenticated();
  const isAllowed = useMemo(
    () => AuthServices.isAuthorised(requiredRoles),
    [requiredRoles]
  );

  useEffect(() => {
    if (!isAuthed) {
      navigate("/login", { replace: true });
    }
  }, [isAuthed, navigate]);

  if (!isAuthed) return null;
  if (!isAllowed) {
    return <AccessDenied />;
  }

  return children;
};

export default RequireRole;

